<template lang="pug">
    v-form(ref="userForm" id="userForm" @submit.prevent="doSave" lazy-validation)
        v-container(grid-list-md)
            v-layout(wrap)
                v-flex(lg3 md3 xs12 v-if="isUpdate")
                    v-text-field(dense v-model="user.username" label="Username" readonly)
                v-flex(lg4 md4 xs12)
                    v-text-field(dense v-model="user.name" label="Nama" :rules="[v => !!v || 'Input Nama']" required)
                v-flex(lg2 md2 xs12)
                    v-text-field(dense v-model="user.nip" label="NIK")
            v-layout(wrap)
                v-flex(lg5 md5 xs12)
                    v-text-field(dense v-model="user.email" label="Email" :rules="[v => !!v || 'Input Email', v => /.+@.+\..+/.test(v) || 'E-mail tidak valid']" required)
                v-flex(lg2 md2 xs12)
                    v-text-field(dense v-model="user.phone" label="No. Handphone" )
            v-layout(wrap)
                v-flex(lg4 md4 xs12)
                    f-select-role(v-model="user.roleId" label="Wewenang" :rules="[v => !!v || 'Input Wewenang']" :required="true" :readonly="isUpdate" :isAdmin="isAdmin" :needVerification="needVerification" v-on:role="setRole")
                v-flex(lg3 md3 xs12)
                    f-decimalbox(v-model="user.limitTransaction" label="Limit Transaksi" :rules="[v => !!v || 'Input Limit Transaksi']" required)
                v-flex(lg4 md4 xs12)
                    f-select-validation-type(v-model="user.validation" label="Jenis Validasi" :rules="[v => !!v || 'Input Jenis Validasi']" :required="true")
            div(justify-center style="text-align: center" class="ma-2 menu-btn")
                v-btn(class="mx-1" @click="doCancel") Kembali
                    v-icon mdi-arrow-left
                v-btn(color="btnprimary white--text" class="mx-1" type="submit" form="userForm") Simpan
                    v-icon mdi-content-save-outline
</template>
<script>
export default {
    name: "FUserForm",
    props: ["isUpdate", "dataUser", "isAdmin", "needVerification"],
    data() {
        return {
            user: {
                corporateId: "",
                corporateGroupId: null,
                userId: null,
                username: "",
                name: "",
                email: "",
                phone: "",
                nip: "",
                roleId: null,
                limitTransaction: 0
            }
        }
    },
    watch: {
        dataUser(val){
            this.doInit(val);
        }
    },
    mounted() {
        this.doInit(this.dataUser);
        
    },
    methods: {
        doInit(values){
            this.user = values ? values : {
                corporateId: "",
                corporateGroupId: null,
                userId: null,
                username: "",
                name: "",
                email: "",
                phone: "",
                nip: "",
                roleId: null,
                roleName: "",
                limitTransaction: 0,
                validation: ""
            }
            if (this.$refs.userForm) {
                this.$refs.userForm.resetValidation();
            }
        },
        doSave(){
            if (this.$refs.userForm.validate()) {
                this.$refs.userForm.resetValidation();
                this.$emit("user", this.user);
            }
        },
        doCancel(){
            this.$refs.userForm.resetValidation();
            this.$emit("cancel");
        },
        setRole(role){
            if (role) {
                this.user.roleName = role.description;
            }
        }
    },
}
</script>